/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
import {
  InsightResponse,
  GenericErrorResponse,
  InsightEventItem,

  InsightEventType
} from './responses';

import { HttpClient, RequestParams, ContentType } from './httpClient';

export class Insights<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @tags Insights
   * @name getInsights
   * @request GET:/insights
   * @description Retrieve a list of all insights.
   * @param {string} teamId The ID of the current team.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `InsightResponse[]` Success
   */
  getInsights = (teamId: string, params: RequestParams = {}) =>
    this.request<InsightResponse[], GenericErrorResponse>({
      path: `/teams/${teamId}/insights`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });

  /**
   * @tags Insights
   * @name getInsight
   * @request GET:/team/{teamId}/insight/{insightId}
   * @description Get an insight by its ID.
   * @param {string} teamId The ID of the current team.
   * @param {string} insightId The ID of the insight to retrieve.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `InsightResponse` Success
   */
  getInsight = (teamId: string, insightId: string, params: RequestParams = {}) =>
    this.request<InsightResponse, GenericErrorResponse>({
      path: `/teams/${teamId}/insights/${insightId}`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });
  /**
   * @tags Insights
   * @name getInsightEvents
   * @request GET:/team/{teamId}/insight/{insightId}/events
   * @description Get an insight events by its insight's D.
   * @param {string} teamId The ID of the current team.
   * @param {string} insightId The ID of the insight.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `InsightEventItem` Success
   */
  getInsightEvents = (teamId: string, insightId: string, params: RequestParams = {}) =>
    this.request<InsightEventItem[], GenericErrorResponse>({
      path: `/teams/${teamId}/insights/${insightId}/events`,
      method: 'GET',
      format: 'json',
      secure: true,
      ...params,
    });
  /**
   * @tags Insights
   * @name mutateInsightEvent
   * @request POST:/team/{teamId}/insight/{insightId}/events
   * @description Mutate an insight event by its insight's ID.
   * @param {string} teamId The ID of the current team.
   * @param {string} insightId The ID of the insight.
   * @param {RequestParams} params Additional request parameters.
   * @response `200` `InsightEventItem` Success
   */
  mutateInsightEvent = (teamId: string, insightId: string, event: InsightEventType, message:string | undefined, params: RequestParams = {}) =>
    this.request<InsightEventItem, GenericErrorResponse>({
      path: `/teams/${teamId}/insights/${insightId}/events`,
      method: 'POST',
      format: 'json',
      type: ContentType.Json,
      secure: true,
      body: { event, message },
      ...params,
    });
}
